import { BaseRoutes } from './base.routes.constants';

export class AntecipacaoListRoutes extends BaseRoutes {
  constructor(route: string) {
    super(route);
  }
}
